import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function isNewStartedUser() {
    // milliseconds in 30 days
    const THIRTY_DAYS_TIMESPAN_IN_MS = 1000 * 60 * 60 * 24 * 30;

    const isNewUserCreated =
        Date.now() - new Date(getUserConfiguration().MailboxCreateDate).getTime() <=
        THIRTY_DAYS_TIMESPAN_IN_MS;

    return isNewUserCreated;
}
